import { useQuery } from '@tanstack/react-query'
import { GetUserProfileApiResponse } from '@valuecase/seller-backend'
import SellerApi from '../../../api/SellerApi'

async function readUserProfileFn() {
  const res = await SellerApi.get<{ payload: GetUserProfileApiResponse }>('/user-profile')
  return res.data.payload
}

export function useReadUserProfile() {
  const query = useQuery({
    queryKey: ['readUserProfile'],
    queryFn: readUserProfileFn,
  })
  return {
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    userProfile: query.data,
    isFetched: query.isFetched,
  }
}
